import * as React from 'react';

import { FormField } from 'components/form';
import ChannelSwitch from 'modules/influencers/components/channels/channel-switch/ChannelSwitch';

import { isArrayRequired } from 'utils/validators';
import { INFLUENCER_CHANNELS_ORDER_NEW } from 'utils/influencers';
import { __t, applyTranslations } from 'utils/language';

import type { ChannelForm } from 'types';

import type { FieldDescriptionShowParams } from 'modules/influencers/components/influencer-create-profile/InfluencerCreateProfile';

applyTranslations(require('./fields-channels.i18n.json'));

type Props = {
  channels: Array<ChannelForm>,
  isAdmin?: boolean,
  isCreationStep?: boolean,
  hasError: boolean,
  expiredAnalyticsDataForInfluencer: {
    [x: string]: boolean
  },
  onChange: (a: Array<ChannelForm>) => void,
  onFieldDescriptionShow?: (p: FieldDescriptionShowParams) => void,
  onFieldDescriptionHide?: () => void
};

class ProfileFormFieldsChannels extends React.PureComponent<Props> {
  componentDidMount() {
    const { onFieldDescriptionShow } = this.props;

    if (onFieldDescriptionShow) {
      onFieldDescriptionShow({
        name: 'channels',
        positionTop: 48,
        width: 464
      });
    }
  }

  componentWillUnmount() {
    const { onFieldDescriptionHide } = this.props;

    if (onFieldDescriptionHide) {
      onFieldDescriptionHide();
    }
  }

  handleChannelChanged = (channel: ChannelForm): void => {
    const { channels, onChange } = this.props;

    const existedChannel = channels.find(c => c.type === channel.type);
    let updatedChannels: Array<ChannelForm> = [];

    if (!existedChannel) {
      updatedChannels = [...channels, channel];
    } else {
      updatedChannels = channels
        .map(c => (c.type === channel.type ? channel : c));
    }

    onChange(updatedChannels.filter(c => Boolean(c.url) || (c.assets && c.assets.length > 0)));
  };

  render() {
    const {
      channels,
      isAdmin,
      isCreationStep,
      hasError,
      expiredAnalyticsDataForInfluencer,
      onFieldDescriptionHide
    } = this.props;

    const hasStaticTooltips = !onFieldDescriptionHide;

    return (
      <section
        className="profile-form-fields"
        data-qa="profile-form-fields-channels"
      >
        <FormField
          label={__t('fields_channels.fields.channels')}
          labelType="highlighted"
          tooltipMessage={hasStaticTooltips ? __t('fields_channels.field_descriptions.channels') : ''}
          direction="column"
          showRequiredMark
          showValidationIcon={false}
          validators={[
            isArrayRequired(
              channels.filter(c => c.type === 'instagram' || c.type === 'youtube' || c.type === 'tiktok'),
              __t('fields_channels.fields.channels_validation_error')
            )
          ]}
        >
          <div className="profile-form-fields__channels">
            {
              INFLUENCER_CHANNELS_ORDER_NEW.map(channelType => {
                const channel = channels.find(c => c.type === channelType) || { type: channelType, url: '' };
                return (
                  <div
                    key={channelType}
                    className="profile-form-fields__channel"
                  >
                    <ChannelSwitch
                      channel={channel}
                      isAdmin={isAdmin}
                      isCreationStep={isCreationStep}
                      hasError={hasError}
                      errorMessage={channel.isInvalid ? __t('fields_channels.url_does_not_exist') : null}
                      expiredAnalyticsDataForInfluencer={expiredAnalyticsDataForInfluencer}
                      onChange={this.handleChannelChanged}
                    />
                  </div>
                );
              })
            }
          </div>
        </FormField>
      </section>
    );
  }
}

export default ProfileFormFieldsChannels;
